export const EventPath = '/events';
export const EventUrls = {
  page: `${EventPath}`,
  create: `${EventPath}/create`,
  update: `${EventPath}/update/:id`,
  getUpdatePath: id => `${EventPath}/update/${id}`,
  detail: `${EventPath}/detail/:id`,
  getDetailPath: id => `${EventPath}/detail/${id}`,
};
